import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/sharingFlag/user.sharingFlag.query.gql"
import type {
  UserSharingFlagQuery,
  UserSharingFlagQueryVariables,
} from "@/v2-backoffice-client/user/sharingFlag/__types__/user.sharingFlag.query"

type Options = QueryHookOptions<
  UserSharingFlagQuery,
  UserSharingFlagQueryVariables
>

export function useUserSharingFlagQuery(options?: Options) {
  return useQuery<UserSharingFlagQuery, UserSharingFlagQueryVariables>(
    query,
    options,
  )
}
